<template>
    <div>
      <Adsense
           ins-class="adsbygoogle example_responsive_1"
           ins-style = "display:block"
           data-ad-client="ca-pub-9600750642603999"
           data-ad-slot="1732934247"
           data-ad-format="auto"
           data-full-width-responsive="true"
      ></Adsense>
    </div>
  </template>
  
  <script setup>
    import Adsense from './Adsense/AdsenseComponent.vue';
  </script>
  
  <style>
  
  </style>
